import React from 'react'
import type { TextProps } from 'react-native'

// eslint-disable-next-line no-restricted-imports
import { Text as RNText } from 'react-native'

import { useTheme, useThemedStylesheet } from '../themes/util'

import type { ThemeFactory } from '../themes/util/types'
import tID from '../utils/testUtils'

const STYLES: ThemeFactory = ({ colors, fonts }) => ({
  text: {
    color: colors.text,
    fontFamily: fonts.defaultMedium,
    fontSize: fonts.defaultSize,
  },
  titleText: {
    textAlign: 'center',
    fontSize: 22,
    fontWeight: '600',
  },
  small: {
    fontSize: 13,
    lineHeight: 18,
    color: colors.colorEmphasizedText,
  },
  bold: {
    fontFamily: fonts.defaultBold,
    color: colors.colorEmphasizedText,
  },
  textLink: {
    fontFamily: fonts.defaultSemibold,
  },
  bodyText: {
    fontSize: 17,
    lineHeight: 27,
  },
  paragraph: {
    marginBottom: 17,
  },
  marquee: {
    marginBottom: 17,
    textAlign: 'center',
  },
  legalParagraph: {
    marginBottom: 13,
  },
})

export function Text({
  style,
  testID,
  ...props
}: TextProps & { testID?: string }) {
  const S = useThemedStylesheet(STYLES)
  return (
    <RNText
      allowFontScaling={false}
      style={[S.text, style]}
      {...props}
      testID={tID(testID)}
    />
  )
}

export function SmallText({ style = {}, ...props }) {
  const S = useThemedStylesheet(STYLES)
  return <Text style={[S.small, style]} {...props} />
}

export function Bold({ style = {}, ...props }) {
  const S = useThemedStylesheet(STYLES)
  return <Text style={[S.bold, style]} {...props} />
}

export function TextLink({ style = {}, ...props }) {
  const { colors } = useTheme()
  const S = useThemedStylesheet(STYLES)
  return (
    <Text
      style={[S.textLink, { color: colors.linkText }, style]}
      {...props}
      testID={tID('system-status-value')}
    />
  )
}

export function BodyText({ style = {}, ...props }) {
  const S = useThemedStylesheet(STYLES)
  return <Text style={[S.bodyText, style]} {...props} />
}

export function TitleText({ style = {}, ...props }) {
  const { colors } = useTheme()
  const S = useThemedStylesheet(STYLES)
  return (
    <Text
      style={[S.titleText, { color: colors.colorEmphasizedText }, style]}
      ellipsizeMode="tail"
      {...props}
    />
  )
}

export function Paragraph({ style = {}, ...props }) {
  const S = useThemedStylesheet(STYLES)
  return <BodyText style={[S.paragraph, style]} {...props} />
}

export function LegalParagraph({ style = {}, ...props }) {
  const S = useThemedStylesheet(STYLES)
  return <SmallText style={[S.legalParagraph, style]} {...props} />
}

export function Marquee({ style = {}, ...props }) {
  const S = useThemedStylesheet(STYLES)
  return <BodyText style={[S.marquee, style]} {...props} />
}
